import * as Types from '../../../../gql/__generated/graphql.types';

import { CollapsibleSectionFieldsFragment } from '../../../product/gql/__generated/collection.generated';
import { SeoMetaDataFragment } from '../../../common/gql/__generated/seoMetadata.generated';
import { CollapsibleSectionFieldsFragmentDoc } from '../../../product/gql/__generated/collection.generated';
import { SeoMetaDataFragmentDoc } from '../../../common/gql/__generated/seoMetadata.generated';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type BrandPageCollectionAllQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BrandPageCollectionAllQuery = (
  { __typename?: 'Query' }
  & { brandPageCollection?: Types.Maybe<(
    { __typename?: 'BrandPageCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandPage' }
      & Pick<Types.BrandPage, 'brand' | 'slug'>
      & { brandLogo?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url'>
      )> }
    )>> }
  )> }
);

export type BrandsListingQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type BrandsListingQuery = (
  { __typename?: 'Query' }
  & { brandPageCollection?: Types.Maybe<(
    { __typename?: 'BrandPageCollection' }
    & Pick<Types.BrandPageCollection, 'total'>
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandPage' }
      & Pick<Types.BrandPage, 'brand' | 'displayBrandName' | 'slug'>
      & { departmentsCollection?: Types.Maybe<(
        { __typename?: 'BrandPageDepartmentsCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'ShopByDepartment' }
          & Pick<Types.ShopByDepartment, 'title' | 'slug'>
        )>> }
      )> }
    )>> }
  )> }
);

export type BrandPageCollectionAllBrandIdsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BrandPageCollectionAllBrandIdsQuery = (
  { __typename?: 'Query' }
  & { brandPageCollection?: Types.Maybe<(
    { __typename?: 'BrandPageCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandPage' }
      & Pick<Types.BrandPage, 'brand' | 'brandId' | 'designShopSection' | 'slug'>
      & { description?: Types.Maybe<(
        { __typename?: 'BrandPageDescription' }
        & Pick<Types.BrandPageDescription, 'json'>
      )>, contentfulMetadata: (
        { __typename?: 'ContentfulMetadata' }
        & { tags: Array<Types.Maybe<(
          { __typename?: 'ContentfulTag' }
          & Pick<Types.ContentfulTag, 'id' | 'name'>
        )>> }
      ) }
    )>> }
  )> }
);

export type BrandPageCollectionAllWithDiscountQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type BrandPageCollectionAllWithDiscountQuery = (
  { __typename?: 'Query' }
  & { brandPageCollection?: Types.Maybe<(
    { __typename?: 'BrandPageCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandPage' }
      & Pick<Types.BrandPage, '_id' | 'brandId' | 'brand' | 'minimumDiscount' | 'instructions' | 'category'>
      & { brandLogo?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url'>
      )> }
    )>> }
  )> }
);

export type BrandTabFieldsFragment = (
  { __typename?: 'BrandTab' }
  & Pick<Types.BrandTab, 'internalName' | 'tabKind' | 'tabTitle' | 'descriptionTitle' | 'displayMode' | 'exploreAllUrl' | 'exploreAllLabel' | 'filterRules' | 'keywordTags' | 'pinnedSkus'>
  & { description?: Types.Maybe<(
    { __typename?: 'BrandTabDescription' }
    & Pick<Types.BrandTabDescription, 'json'>
  )>, department?: Types.Maybe<(
    { __typename?: 'ShopByDepartment' }
    & Pick<Types.ShopByDepartment, 'slug' | 'title' | 'pageTitle'>
    & { seo?: Types.Maybe<(
      { __typename?: 'SeoMetadata' }
      & Pick<Types.SeoMetadata, 'description'>
    )>, categoryLvl1?: Types.Maybe<(
      { __typename?: 'SceneHierarchy' }
      & Pick<Types.SceneHierarchy, 'hirearchy'>
    )>, categoryLvl2Collection?: Types.Maybe<(
      { __typename?: 'ShopByDepartmentCategoryLvl2Collection' }
      & { items: Array<Types.Maybe<(
        { __typename?: 'SceneHierarchy' }
        & Pick<Types.SceneHierarchy, 'hirearchy'>
      )>> }
    )> }
  )>, imagesCollection?: Types.Maybe<(
    { __typename?: 'AssetCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'ContentfullAsset' }
      & Pick<Types.ContentfullAsset, 'url' | 'title' | 'fileName'>
    )>> }
  )>, slidesCollection?: Types.Maybe<(
    { __typename?: 'BrandTabSlidesCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandStorySlide' }
      & Pick<Types.BrandStorySlide, 'internalName' | 'mediaType' | 'videoSource' | 'videoEmbedUrl'>
      & { image?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url' | 'title' | 'fileName'>
      )>, nativeVideo?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url' | 'title' | 'fileName' | 'contentType'>
      )> }
    )>> }
  )> }
);

export type BrandPageCollectionQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type BrandPageCollectionQuery = (
  { __typename?: 'Query' }
  & { brandPageCollection?: Types.Maybe<(
    { __typename?: 'BrandPageCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandPage' }
      & Pick<Types.BrandPage, 'brandId' | 'useNewLayout' | 'descriptionTitle' | 'collectionsTitle' | 'collectionsSubtitle' | 'whereToBuyTitle' | 'whereToBuySubtitle' | 'brand' | 'website' | 'designShopSection'>
      & { heroBackgroundImage?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url' | 'title' | 'fileName'>
      )>, whereToBuyImage?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url' | 'title' | 'fileName'>
      )>, whereToBuyNote?: Types.Maybe<(
        { __typename?: 'BrandPageWhereToBuyNote' }
        & Pick<Types.BrandPageWhereToBuyNote, 'json'>
      )>, socialLinksCollection?: Types.Maybe<(
        { __typename?: 'BrandPageSocialLinksCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'SocialLink' }
          & Pick<Types.SocialLink, 'internalName' | 'url'>
          & { icon?: Types.Maybe<(
            { __typename?: 'ContentfullAsset' }
            & Pick<Types.ContentfullAsset, 'url' | 'title' | 'fileName'>
          )> }
        )>> }
      )>, categoryTabsCollection?: Types.Maybe<(
        { __typename?: 'BrandPageCategoryTabsCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'BrandTab' }
          & BrandTabFieldsFragment
        )>> }
      )>, shopSamplesTabsCollection?: Types.Maybe<(
        { __typename?: 'BrandPageShopSamplesTabsCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'BrandTab' }
          & BrandTabFieldsFragment
        )>> }
      )>, brandStoriesTabsCollection?: Types.Maybe<(
        { __typename?: 'BrandPageBrandStoriesTabsCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'BrandTab' }
          & BrandTabFieldsFragment
        )>> }
      )>, reasonsToLoveCollection?: Types.Maybe<(
        { __typename?: 'BrandPageReasonsToLoveCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'BrandReason' }
          & Pick<Types.BrandReason, 'internalName' | 'title'>
          & { body?: Types.Maybe<(
            { __typename?: 'BrandReasonBody' }
            & Pick<Types.BrandReasonBody, 'json'>
          )>, image?: Types.Maybe<(
            { __typename?: 'ContentfullAsset' }
            & Pick<Types.ContentfullAsset, 'url' | 'title' | 'fileName'>
          )> }
        )>> }
      )>, faqSectionsCollection?: Types.Maybe<(
        { __typename?: 'BrandPageFaqSectionsCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'CollapsibleSection' }
          & CollapsibleSectionFieldsFragment
        )>> }
      )>, samplesCollection?: Types.Maybe<(
        { __typename?: 'BrandPageSamplesCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'BrandSample' }
          & Pick<Types.BrandSample, 'category' | 'enabled' | 'skus'>
        )>> }
      )>, brandLogo?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url' | 'fileName' | 'title'>
      )>, brandLogoLight?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url' | 'fileName' | 'title'>
      )>, description?: Types.Maybe<(
        { __typename?: 'BrandPageDescription' }
        & Pick<Types.BrandPageDescription, 'json'>
      )>, brandImagesCollection?: Types.Maybe<(
        { __typename?: 'AssetCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'ContentfullAsset' }
          & Pick<Types.ContentfullAsset, 'fileName' | 'url' | 'title'>
        )>> }
      )>, collectionsCollection?: Types.Maybe<(
        { __typename?: 'BrandPageCollectionsCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'Collection' }
          & Pick<Types.Collection, 'collectionName' | 'description' | 'products' | 'slug' | 'baseImage' | 'exactMatches' | 'roomType' | 'roomStyle'>
          & { sys: (
            { __typename?: 'Sys' }
            & Pick<Types.Sys, 'id'>
          ) }
        )>> }
      )>, visualizerRoomsCollection?: Types.Maybe<(
        { __typename?: 'BrandPageVisualizerRoomsCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'DmaScenes' }
          & Pick<Types.DmaScenes, 'id' | 'title' | 'backgroundDayUrl' | 'backgroundNightUrl' | 'surfaces' | 'internalName'>
        )>> }
      )>, featuredServicesCollection?: Types.Maybe<(
        { __typename?: 'BrandPageFeaturedServicesCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'ImageWithTexts' }
          & Pick<Types.ImageWithTexts, 'description'>
          & { image?: Types.Maybe<(
            { __typename?: 'ContentfullAsset' }
            & Pick<Types.ContentfullAsset, 'url' | 'fileName' | 'title'>
          )> }
        )>> }
      )>, accordionSectionsCollection?: Types.Maybe<(
        { __typename?: 'BrandPageAccordionSectionsCollection' }
        & { items: Array<Types.Maybe<(
          { __typename?: 'ComponentText' }
          & Pick<Types.ComponentText, 'title'>
          & { text?: Types.Maybe<(
            { __typename?: 'ComponentTextText' }
            & Pick<Types.ComponentTextText, 'json'>
          )> }
        )>> }
      )> }
    )>> }
  )> }
);

export type BrandPageCollectionSeoQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type BrandPageCollectionSeoQuery = (
  { __typename?: 'Query' }
  & { brandPageCollection?: Types.Maybe<(
    { __typename?: 'BrandPageCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandPage' }
      & Pick<Types.BrandPage, 'brand'>
      & { seo?: Types.Maybe<(
        { __typename?: 'SeoMetadata' }
        & SeoMetaDataFragment
      )> }
    )>> }
  )> }
);

export type BrandPageCollectionSlugQueryVariables = Types.Exact<{
  title?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type BrandPageCollectionSlugQuery = (
  { __typename?: 'Query' }
  & { brandPageCollection?: Types.Maybe<(
    { __typename?: 'BrandPageCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandPage' }
      & Pick<Types.BrandPage, 'slug' | 'brand' | 'brandId'>
    )>> }
  )> }
);

export type BrandPageCollectionSlugByBrandIdQueryVariables = Types.Exact<{
  brandId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type BrandPageCollectionSlugByBrandIdQuery = (
  { __typename?: 'Query' }
  & { brandPageCollection?: Types.Maybe<(
    { __typename?: 'BrandPageCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandPage' }
      & Pick<Types.BrandPage, 'slug' | 'brand'>
    )>> }
  )> }
);

export type BrandPageCollectionBrandQueryVariables = Types.Exact<{
  brand?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type BrandPageCollectionBrandQuery = (
  { __typename?: 'Query' }
  & { brandPageCollection?: Types.Maybe<(
    { __typename?: 'BrandPageCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandPage' }
      & Pick<Types.BrandPage, 'brand' | 'minimumDiscount' | 'instructions'>
      & { brandLogo?: Types.Maybe<(
        { __typename?: 'ContentfullAsset' }
        & Pick<Types.ContentfullAsset, 'url'>
      )> }
    )>> }
  )> }
);

export type BrandSitemapQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type BrandSitemapQuery = (
  { __typename?: 'Query' }
  & { brandPageCollection?: Types.Maybe<(
    { __typename?: 'BrandPageCollection' }
    & Pick<Types.BrandPageCollection, 'total'>
    & { items: Array<Types.Maybe<(
      { __typename?: 'BrandPage' }
      & Pick<Types.BrandPage, 'slug'>
    )>> }
  )> }
);


export const BrandTabFieldsFragmentDoc = `
    fragment BrandTabFields on BrandTab {
  internalName
  tabKind
  tabTitle
  descriptionTitle
  description {
    json
  }
  displayMode
  exploreAllUrl
  exploreAllLabel
  filterRules
  keywordTags
  pinnedSkus
  department {
    ... on ShopByDepartment {
      slug
      title
      pageTitle
      seo {
        description
      }
      categoryLvl1 {
        hirearchy
      }
      categoryLvl2Collection(limit: 25) {
        items {
          hirearchy
        }
      }
    }
  }
  imagesCollection(limit: 4) {
    items {
      url
      title
      fileName
    }
  }
  slidesCollection(limit: 8) {
    items {
      internalName
      mediaType
      videoSource
      videoEmbedUrl
      image {
        url
        title
        fileName
      }
      nativeVideo {
        url
        title
        fileName
        contentType
      }
    }
  }
}
    `;
export const BrandPageCollectionAllDocument = `
    query brandPageCollectionAll {
  brandPageCollection {
    items {
      brandLogo {
        url
      }
      brand
      slug
    }
  }
}
    `;

export const useBrandPageCollectionAllQuery = <
      TData = BrandPageCollectionAllQuery,
      TError = unknown
    >(
      variables?: BrandPageCollectionAllQueryVariables,
      options?: Omit<UseQueryOptions<BrandPageCollectionAllQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandPageCollectionAllQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandPageCollectionAllQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandPageCollectionAll'] : ['brandPageCollectionAll', variables],
    queryFn: graphqlFetcher<BrandPageCollectionAllQuery, BrandPageCollectionAllQueryVariables>(BrandPageCollectionAllDocument, variables),
    ...options
  }
    )};

useBrandPageCollectionAllQuery.getKey = (variables?: BrandPageCollectionAllQueryVariables) => variables === undefined ? ['brandPageCollectionAll'] : ['brandPageCollectionAll', variables];


useBrandPageCollectionAllQuery.fetcher = (variables?: BrandPageCollectionAllQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BrandPageCollectionAllQuery, BrandPageCollectionAllQueryVariables>(BrandPageCollectionAllDocument, variables, options);

export const BrandsListingDocument = `
    query brandsListing($skip: Int, $limit: Int) {
  brandPageCollection(skip: $skip, limit: $limit, order: brand_ASC) {
    total
    items {
      brand
      displayBrandName
      slug
      departmentsCollection(limit: 25) {
        items {
          title
          slug
        }
      }
    }
  }
}
    `;

export const useBrandsListingQuery = <
      TData = BrandsListingQuery,
      TError = unknown
    >(
      variables?: BrandsListingQueryVariables,
      options?: Omit<UseQueryOptions<BrandsListingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandsListingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandsListingQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandsListing'] : ['brandsListing', variables],
    queryFn: graphqlFetcher<BrandsListingQuery, BrandsListingQueryVariables>(BrandsListingDocument, variables),
    ...options
  }
    )};

useBrandsListingQuery.getKey = (variables?: BrandsListingQueryVariables) => variables === undefined ? ['brandsListing'] : ['brandsListing', variables];


useBrandsListingQuery.fetcher = (variables?: BrandsListingQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BrandsListingQuery, BrandsListingQueryVariables>(BrandsListingDocument, variables, options);

export const BrandPageCollectionAllBrandIdsDocument = `
    query brandPageCollectionAllBrandIds {
  brandPageCollection {
    items {
      brand
      brandId
      description {
        json
      }
      designShopSection
      slug
      contentfulMetadata {
        tags {
          id
          name
        }
      }
    }
  }
}
    `;

export const useBrandPageCollectionAllBrandIdsQuery = <
      TData = BrandPageCollectionAllBrandIdsQuery,
      TError = unknown
    >(
      variables?: BrandPageCollectionAllBrandIdsQueryVariables,
      options?: Omit<UseQueryOptions<BrandPageCollectionAllBrandIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandPageCollectionAllBrandIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandPageCollectionAllBrandIdsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandPageCollectionAllBrandIds'] : ['brandPageCollectionAllBrandIds', variables],
    queryFn: graphqlFetcher<BrandPageCollectionAllBrandIdsQuery, BrandPageCollectionAllBrandIdsQueryVariables>(BrandPageCollectionAllBrandIdsDocument, variables),
    ...options
  }
    )};

useBrandPageCollectionAllBrandIdsQuery.getKey = (variables?: BrandPageCollectionAllBrandIdsQueryVariables) => variables === undefined ? ['brandPageCollectionAllBrandIds'] : ['brandPageCollectionAllBrandIds', variables];


useBrandPageCollectionAllBrandIdsQuery.fetcher = (variables?: BrandPageCollectionAllBrandIdsQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BrandPageCollectionAllBrandIdsQuery, BrandPageCollectionAllBrandIdsQueryVariables>(BrandPageCollectionAllBrandIdsDocument, variables, options);

export const BrandPageCollectionAllWithDiscountDocument = `
    query brandPageCollectionAllWithDiscount($limit: Int) {
  brandPageCollection(
    limit: $limit
    where: {minimumDiscount_exists: true, minimumDiscount_not: null}
    order: brand_ASC
  ) {
    items {
      brandLogo {
        url
      }
      _id
      brandId
      brand
      minimumDiscount
      instructions
      category
    }
  }
}
    `;

export const useBrandPageCollectionAllWithDiscountQuery = <
      TData = BrandPageCollectionAllWithDiscountQuery,
      TError = unknown
    >(
      variables?: BrandPageCollectionAllWithDiscountQueryVariables,
      options?: Omit<UseQueryOptions<BrandPageCollectionAllWithDiscountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandPageCollectionAllWithDiscountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandPageCollectionAllWithDiscountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandPageCollectionAllWithDiscount'] : ['brandPageCollectionAllWithDiscount', variables],
    queryFn: graphqlFetcher<BrandPageCollectionAllWithDiscountQuery, BrandPageCollectionAllWithDiscountQueryVariables>(BrandPageCollectionAllWithDiscountDocument, variables),
    ...options
  }
    )};

useBrandPageCollectionAllWithDiscountQuery.getKey = (variables?: BrandPageCollectionAllWithDiscountQueryVariables) => variables === undefined ? ['brandPageCollectionAllWithDiscount'] : ['brandPageCollectionAllWithDiscount', variables];


useBrandPageCollectionAllWithDiscountQuery.fetcher = (variables?: BrandPageCollectionAllWithDiscountQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BrandPageCollectionAllWithDiscountQuery, BrandPageCollectionAllWithDiscountQueryVariables>(BrandPageCollectionAllWithDiscountDocument, variables, options);

export const BrandPageCollectionDocument = `
    query brandPageCollection($slug: String, $limit: Int) {
  brandPageCollection(where: {slug: $slug}, limit: 1) {
    items {
      brandId
      useNewLayout
      descriptionTitle
      collectionsTitle
      collectionsSubtitle
      heroBackgroundImage {
        url
        title
        fileName
      }
      whereToBuyImage {
        url
        title
        fileName
      }
      whereToBuyTitle
      whereToBuySubtitle
      whereToBuyNote {
        json
      }
      socialLinksCollection(limit: 8) {
        items {
          internalName
          url
          icon {
            url
            title
            fileName
          }
        }
      }
      categoryTabsCollection(limit: 6) {
        items {
          ...BrandTabFields
        }
      }
      shopSamplesTabsCollection(limit: 6) {
        items {
          ...BrandTabFields
        }
      }
      brandStoriesTabsCollection(limit: 6) {
        items {
          ...BrandTabFields
        }
      }
      reasonsToLoveCollection(limit: 8) {
        items {
          internalName
          title
          body {
            json
          }
          image {
            url
            title
            fileName
          }
        }
      }
      faqSectionsCollection(limit: 12) {
        items {
          ...CollapsibleSectionFields
        }
      }
      samplesCollection(limit: $limit) {
        items {
          category
          enabled
          skus
        }
      }
      brandLogo {
        url
        fileName
        title
      }
      brandLogoLight {
        url
        fileName
        title
      }
      brand
      description {
        json
      }
      website
      brandImagesCollection(limit: $limit) {
        items {
          fileName
          url
          title
        }
      }
      collectionsCollection(limit: $limit) {
        items {
          sys {
            id
          }
          collectionName
          description
          products
          slug
          baseImage
          exactMatches
          roomType
          roomStyle
        }
      }
      visualizerRoomsCollection(limit: $limit) {
        items {
          id
          title
          backgroundDayUrl
          backgroundNightUrl
          surfaces
          internalName
        }
      }
      designShopSection
      featuredServicesCollection(limit: $limit) {
        items {
          description
          image {
            url
            fileName
            title
          }
        }
      }
      accordionSectionsCollection(limit: $limit) {
        items {
          title
          text {
            json
          }
        }
      }
    }
  }
}
    ${BrandTabFieldsFragmentDoc}
${CollapsibleSectionFieldsFragmentDoc}`;

export const useBrandPageCollectionQuery = <
      TData = BrandPageCollectionQuery,
      TError = unknown
    >(
      variables?: BrandPageCollectionQueryVariables,
      options?: Omit<UseQueryOptions<BrandPageCollectionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandPageCollectionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandPageCollectionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandPageCollection'] : ['brandPageCollection', variables],
    queryFn: graphqlFetcher<BrandPageCollectionQuery, BrandPageCollectionQueryVariables>(BrandPageCollectionDocument, variables),
    ...options
  }
    )};

useBrandPageCollectionQuery.getKey = (variables?: BrandPageCollectionQueryVariables) => variables === undefined ? ['brandPageCollection'] : ['brandPageCollection', variables];


useBrandPageCollectionQuery.fetcher = (variables?: BrandPageCollectionQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BrandPageCollectionQuery, BrandPageCollectionQueryVariables>(BrandPageCollectionDocument, variables, options);

export const BrandPageCollectionSeoDocument = `
    query brandPageCollectionSeo($slug: String) {
  brandPageCollection(where: {slug: $slug}) {
    items {
      brand
      seo {
        ...SeoMetaData
      }
    }
  }
}
    ${SeoMetaDataFragmentDoc}`;

export const useBrandPageCollectionSeoQuery = <
      TData = BrandPageCollectionSeoQuery,
      TError = unknown
    >(
      variables?: BrandPageCollectionSeoQueryVariables,
      options?: Omit<UseQueryOptions<BrandPageCollectionSeoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandPageCollectionSeoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandPageCollectionSeoQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandPageCollectionSeo'] : ['brandPageCollectionSeo', variables],
    queryFn: graphqlFetcher<BrandPageCollectionSeoQuery, BrandPageCollectionSeoQueryVariables>(BrandPageCollectionSeoDocument, variables),
    ...options
  }
    )};

useBrandPageCollectionSeoQuery.getKey = (variables?: BrandPageCollectionSeoQueryVariables) => variables === undefined ? ['brandPageCollectionSeo'] : ['brandPageCollectionSeo', variables];


useBrandPageCollectionSeoQuery.fetcher = (variables?: BrandPageCollectionSeoQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BrandPageCollectionSeoQuery, BrandPageCollectionSeoQueryVariables>(BrandPageCollectionSeoDocument, variables, options);

export const BrandPageCollectionSlugDocument = `
    query brandPageCollectionSlug($title: String) {
  brandPageCollection(where: {brand_contains: $title}) {
    items {
      slug
      brand
      brandId
    }
  }
}
    `;

export const useBrandPageCollectionSlugQuery = <
      TData = BrandPageCollectionSlugQuery,
      TError = unknown
    >(
      variables?: BrandPageCollectionSlugQueryVariables,
      options?: Omit<UseQueryOptions<BrandPageCollectionSlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandPageCollectionSlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandPageCollectionSlugQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandPageCollectionSlug'] : ['brandPageCollectionSlug', variables],
    queryFn: graphqlFetcher<BrandPageCollectionSlugQuery, BrandPageCollectionSlugQueryVariables>(BrandPageCollectionSlugDocument, variables),
    ...options
  }
    )};

useBrandPageCollectionSlugQuery.getKey = (variables?: BrandPageCollectionSlugQueryVariables) => variables === undefined ? ['brandPageCollectionSlug'] : ['brandPageCollectionSlug', variables];


useBrandPageCollectionSlugQuery.fetcher = (variables?: BrandPageCollectionSlugQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BrandPageCollectionSlugQuery, BrandPageCollectionSlugQueryVariables>(BrandPageCollectionSlugDocument, variables, options);

export const BrandPageCollectionSlugByBrandIdDocument = `
    query brandPageCollectionSlugByBrandId($brandId: String) {
  brandPageCollection(where: {brandId: $brandId}) {
    items {
      slug
      brand
    }
  }
}
    `;

export const useBrandPageCollectionSlugByBrandIdQuery = <
      TData = BrandPageCollectionSlugByBrandIdQuery,
      TError = unknown
    >(
      variables?: BrandPageCollectionSlugByBrandIdQueryVariables,
      options?: Omit<UseQueryOptions<BrandPageCollectionSlugByBrandIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandPageCollectionSlugByBrandIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandPageCollectionSlugByBrandIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandPageCollectionSlugByBrandId'] : ['brandPageCollectionSlugByBrandId', variables],
    queryFn: graphqlFetcher<BrandPageCollectionSlugByBrandIdQuery, BrandPageCollectionSlugByBrandIdQueryVariables>(BrandPageCollectionSlugByBrandIdDocument, variables),
    ...options
  }
    )};

useBrandPageCollectionSlugByBrandIdQuery.getKey = (variables?: BrandPageCollectionSlugByBrandIdQueryVariables) => variables === undefined ? ['brandPageCollectionSlugByBrandId'] : ['brandPageCollectionSlugByBrandId', variables];


useBrandPageCollectionSlugByBrandIdQuery.fetcher = (variables?: BrandPageCollectionSlugByBrandIdQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BrandPageCollectionSlugByBrandIdQuery, BrandPageCollectionSlugByBrandIdQueryVariables>(BrandPageCollectionSlugByBrandIdDocument, variables, options);

export const BrandPageCollectionBrandDocument = `
    query brandPageCollectionBrand($brand: String) {
  brandPageCollection(
    where: {brand_contains: $brand, minimumDiscount_exists: true, minimumDiscount_not: null}
  ) {
    items {
      brandLogo {
        url
      }
      brand
      minimumDiscount
      instructions
    }
  }
}
    `;

export const useBrandPageCollectionBrandQuery = <
      TData = BrandPageCollectionBrandQuery,
      TError = unknown
    >(
      variables?: BrandPageCollectionBrandQueryVariables,
      options?: Omit<UseQueryOptions<BrandPageCollectionBrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandPageCollectionBrandQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandPageCollectionBrandQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandPageCollectionBrand'] : ['brandPageCollectionBrand', variables],
    queryFn: graphqlFetcher<BrandPageCollectionBrandQuery, BrandPageCollectionBrandQueryVariables>(BrandPageCollectionBrandDocument, variables),
    ...options
  }
    )};

useBrandPageCollectionBrandQuery.getKey = (variables?: BrandPageCollectionBrandQueryVariables) => variables === undefined ? ['brandPageCollectionBrand'] : ['brandPageCollectionBrand', variables];


useBrandPageCollectionBrandQuery.fetcher = (variables?: BrandPageCollectionBrandQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BrandPageCollectionBrandQuery, BrandPageCollectionBrandQueryVariables>(BrandPageCollectionBrandDocument, variables, options);

export const BrandSitemapDocument = `
    query brandSitemap($skip: Int, $limit: Int) {
  brandPageCollection(skip: $skip, limit: $limit) {
    total
    items {
      slug
    }
  }
}
    `;

export const useBrandSitemapQuery = <
      TData = BrandSitemapQuery,
      TError = unknown
    >(
      variables?: BrandSitemapQueryVariables,
      options?: Omit<UseQueryOptions<BrandSitemapQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandSitemapQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandSitemapQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandSitemap'] : ['brandSitemap', variables],
    queryFn: graphqlFetcher<BrandSitemapQuery, BrandSitemapQueryVariables>(BrandSitemapDocument, variables),
    ...options
  }
    )};

useBrandSitemapQuery.getKey = (variables?: BrandSitemapQueryVariables) => variables === undefined ? ['brandSitemap'] : ['brandSitemap', variables];


useBrandSitemapQuery.fetcher = (variables?: BrandSitemapQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<BrandSitemapQuery, BrandSitemapQueryVariables>(BrandSitemapDocument, variables, options);
